export const STRENGTH_SCALE_MAX = 10
export const STRENGTH_SCALE_MIN_FILLED = 1
export const NICOTINE_TO_TAR_SCALE_FACTOR = 10
